import BusinessPermissions from "../../Adviser/Constants/BusinessPermissions";
import AdviserStatus from "../../Adviser/Constants/Status";

const aliases = Object.entries(AdviserStatus).reduce((result, [key, code]) => {
  result[code.toLowerCase()] = code;
  result[BusinessPermissions[key].toLowerCase()] = code;
  return result;
}, {});

// Older recruitment updates store names or comma-separated codes, rather than arrays.
export const normalizeRecruitmentPermissions = (value) => {
  const entries = Array.isArray(value) ? value : [value];
  return [...new Set(entries.flatMap((entry) =>
    String(entry ?? "").split(/[,;/]/).map((item) => item.trim()).filter(Boolean)
      .map((item) => aliases[item.toLowerCase()] || item),
  ))];
};

export const resolveRecruitmentPermissions = (adviser, update = {}) =>
  normalizeRecruitmentPermissions(adviser?.status ?? update.status ?? update.permission);
